import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=a7621994&"
import script from "./Ecommerce.vue?vue&type=script&lang=js&"
export * from "./Ecommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7621994')) {
      api.createRecord('a7621994', component.options)
    } else {
      api.reload('a7621994', component.options)
    }
    module.hot.accept("./Ecommerce.vue?vue&type=template&id=a7621994&", function () {
      api.rerender('a7621994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/dashboard/Ecommerce.vue"
export default component.exports